import React from 'react';
import PropTypes from 'prop-types';

const ShippingDate = props => <p>{props.shippingDate}</p>;

ShippingDate.propTypes = {
  shippingDate: PropTypes.string,
};

export default ShippingDate;



// WEBPACK FOOTER //
// ./src/client/js/view/components/Shipping/ShippingDate/ShippingDate.js